import { lazy, Suspense, useRef } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Main, Wrapper } from './content.styles';

import ErrorBoundary from '../../error_boundary';
import LoadingText from '../../loading_text';
import ScrollToTop from '../../scroll_to_top';
import Title from '../../title';
import Header from './header';

const HomePage = lazy(() => import('./home'));
const MapPage = lazy(() => import('./map'));
const InboxPage = lazy(() => import('./inbox'));
const ChallengesPage = lazy(() => import('./challenges'));
const CardSubscriptionsPage = lazy(() => import('./card_subscriptions'));
const ProfilePage = lazy(() => import('./profile'));
const CameraPage = lazy(() => import('./camera'));
const RedeemPage = lazy(() => import('./redeem'));

const PWAPopover = lazy(() => import('./pwa_popover'));

export default function Content() {
  const wrapper = useRef<HTMLDivElement>(null);

  return (
    <>
      <ErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <PWAPopover />
        </Suspense>
      </ErrorBoundary>
      <Wrapper ref={wrapper}>
        <Title />
        <ScrollToTop wrapper={wrapper} />
        <Routes>
          <Route element={<Header />} path="" />
          <Route element={<Header />} path="inbox" />
          <Route element={<Header />} path="challenges" />
        </Routes>
        <Main>
          <Suspense fallback={<LoadingText />}>
            <Routes>
              <Route element={<HomePage />} path="" />
              <Route element={<MapPage />} path="map/*" />
              <Route element={<InboxPage />} path="inbox/*" />
              <Route element={<ChallengesPage />} path="challenges/*" />
              <Route element={<CardSubscriptionsPage />} path="card_subscriptions/*" />
              <Route element={<ProfilePage />} path="profile/*" />
              <Route element={<CameraPage />} path="camera/*" />
              <Route element={<RedeemPage />} path="redeem/*" />
              <Route element={<Navigate to="/" />} path="*" />
            </Routes>
          </Suspense>
        </Main>
      </Wrapper>
    </>
  );
}
